import { API } from '@/shared/api/modules';
import type { GetExpensesRequestDto } from '@/shared/api/modules/facilities';
import { queryOptions } from '@tanstack/react-query';

export const getExpensesQueryOptions = (params: GetExpensesRequestDto) =>
  queryOptions({
    queryKey: ['expenses', params],
    queryFn: async ({ signal }) => {
      const response = await API.facilities.getExpenses(params, {
        signal,
      });

      return response;
    },
    enabled: !!params.from && !!params.to,
  });
